import { IconButton, Stack, styled } from '@mui/material'
import Link from 'next/link'
import React from 'react'
import { Email, Telegram, Twitter } from '@mui/icons-material'
import DescriptionIcon from '@mui/icons-material/Description'
import { ReactComponent as MediumSvg } from '@/assets/imgs/Mobile/medium.svg'

const StyledIconButton = styled(IconButton)`
  opacity: 0.4;

  :hover {
    opacity: 1;
  }
`

const SocialMediaLinkGroup = () => {
  return (
    <Stack direction={'row'} spacing={12} alignContent={'center'}>
      <Link href="https://docs.multibit.exchange/multibit" target="_blank">
        <StyledIconButton>
          <DescriptionIcon />
        </StyledIconButton>
      </Link>
      <Link href="mailto:info@multibit.exchange" target="_blank">
        <StyledIconButton>
          <Email />
        </StyledIconButton>
      </Link>
      <Link href="https://t.me/multibitprotocol" target="_blank">
        <StyledIconButton>
          <Telegram />
        </StyledIconButton>
      </Link>
      <Link href="https://twitter.com/Multibit_Bridge" target="_blank">
        <StyledIconButton>
          <Twitter />
        </StyledIconButton>
      </Link>
      <Link href="https://medium.com/@Multibit_Bridge" target="_blank">
        <StyledIconButton>
          <MediumSvg />
        </StyledIconButton>
      </Link>
    </Stack>
  )
}

export default SocialMediaLinkGroup
